import { useState, useEffect } from 'react';
import { Menu, X} from 'lucide-react';
import ThemeToggle from './ThemeToggle';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Features', href: '#features' },
    { name: 'Pricing', href: '#pricing' },
    { name: 'FAQ', href: '#faq' },
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-white/5 backdrop-blur-xl' : 'bg-transparent'}`}>
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center space-x-2">
          <img src="/icon.png" alt="com0.org" height='40' width='40' />
            <span className="text-xl font-bold text-theme-primary">com0.org</span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
className="text-theme-secondary hover:text-theme-primary transition-colors"
              >
                {link.name}
              </a>
            ))}
            <ThemeToggle />
            <a
              href="https://domains0.com"
              target="_blank"
              rel="noopener noreferrer"
              className="glass-button text-white px-6 py-2 rounded-lg block text-center"
            >
              Get Started
            </a>
          </div>

          {/* Mobile menu button and theme toggle */}
          <div className="md:hidden flex items-center space-x-4">
            <ThemeToggle />
            <button
              className="text-theme-primary"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-theme">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
className="block py-2 text-theme-secondary hover:text-theme-primary transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                {link.name}
              </a>
            ))}
            <a
              href="https://domains0.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full mt-4 glass-button text-white px-6 py-2 rounded-lg block text-center"
            >
              Get Started
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}
